import React from "react";
import { range } from "lodash";

export interface YearSelectorProps {
    onChange: (year: number | null) => void;
    selectedYear: number | null;
    minYear: number;
    maxYear: number;
    placeholder?: string;
    disabled?: boolean;
    required?: boolean;
    allowNulls?: boolean;
}

export class YearSelector extends React.PureComponent<YearSelectorProps>{
    onChange = (e: React.FormEvent<HTMLSelectElement>) => {
        const eventValue = (e.target as any).value;
        if (!eventValue) this.props.onChange(null);
        let year = +eventValue;
        if (this.props.selectedYear != year)
            this.props.onChange(year);
    }

    render() {
        return (
            <select className="form-control"
                disabled={this.props.disabled}
                required={this.props.required}
                onChange={this.onChange}
                value={this.props.selectedYear != null ? this.props.selectedYear.toString() : ""}>
                {this.props.allowNulls && <option key={-1} value="">
                    {this.props.placeholder}
                </option>}
                {range(this.props.minYear, this.props.maxYear + 1)
                    .map(year => <option key={year} value={year.toString()}>
                        {year}
                    </option>)}
            </select>);
    }
}
